import React, { createContext, PropsWithChildren, useState } from "react";
import { ResponseVehicle } from "../../../types/api";

function toggleValue(arr: string[], value: string): string[] {
  return arr.includes(value) ? arr.filter(item => item !== value) : [...arr, value];
}

interface VisualToggleContextInterface {
  acodes: ResponseVehicle['acode'][];
  set: (acode : ResponseVehicle['acode']) => void;
}

export const VisualToggleContext = createContext<VisualToggleContextInterface | null>(null);

const VisualToggleContextProvider = ({children} : PropsWithChildren) => {
  const [acodes, setAcodes] = useState<ResponseVehicle['acode'][]>([]);

  const onSetVehicles = (acode : ResponseVehicle['acode']) => {
    const newAcodes = toggleValue(acodes, acode);

    setAcodes(newAcodes)
  }

  return (
    <VisualToggleContext.Provider value={{acodes, set: onSetVehicles}}>
      {children}
    </VisualToggleContext.Provider>
  )
}

export default VisualToggleContextProvider;